export default __webpack_public_path__ + "static/media/002-children.74bc7454.svg";